import React from "react";
import FactualQuestionsCompactView from "./FactualQuestionsCompactView";
import { useFactualQuestionsCompactView } from "./useFactualQuestionsCompactView";

export default function FactualQuestionsCompactViewContainer() {
  const {
    factualQuestions,
    handleSubmit,
    handleChange,
    questionsAndAnswers,
    isContinueClicked
  } = useFactualQuestionsCompactView();
  return (
    <FactualQuestionsCompactView
      questions={factualQuestions}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      questionsAndAnswers={questionsAndAnswers}
      isContinueClicked={isContinueClicked}
    />
  );
}
